module.exports = __webpack_public_path__ + "static/media/louis-hansel-ZwpX0AJ7GV8-unsplash.228c63d3.jpg";